/* global $ */
import themeable from 'rlink-theme/themeable';

import { createElement, Component, PropTypes } from 'rlink-react';

import Profile from 'components/AboutUs/Profile';
import teamScene from 'helpers/scenes/teamScene';

const PORTRAITS_PER_SLIDE = 3;
const PORTRAITS_PER_MOBILE_SLIDE = 1;
const PORTRAITS_TO_SCROLL = 1;
const PORTRAITS_MOBILE_TO_SCROLL = 1;
export default class TeamSection extends Component {

  get slideItemWidth () {
    return ((document.querySelectorAll('#meet-team .slick-track')[0].clientWidth) / PORTRAITS_PER_SLIDE);
  }

  get sliderItemCount () {
    return this.props.profileSliderData.length;
  }

  totalSlides () {
    return Math.max(1, 1 + Math.ceil((this.sliderItemCount - this.portraitsToShow()) / this.portraitsToScroll()));
  }

  portraitsToScroll () {
    let portraitsToScroll = PORTRAITS_TO_SCROLL;
    if (window.innerWidth < 640) {
      portraitsToScroll = PORTRAITS_MOBILE_TO_SCROLL;
    }
    return portraitsToScroll;
  }

  portraitsToShow () {
    let portraitsToShow = PORTRAITS_PER_SLIDE;
    if (window.innerWidth < 640) {
      portraitsToShow = PORTRAITS_PER_MOBILE_SLIDE;
    }
    return portraitsToShow;
  }

  isLastSlide (slide) {
    return slide === this.totalSlides();
  }

  updateDisabledArrows (slide = 1) {
    let leftButton = document.querySelector('#meet-team .slick-prev');
    leftButton.classList.remove('slick-disabled');
    if (slide === 1) {
      leftButton.classList.add('slick-disabled');
    }

    let rightButton = document.querySelector('#meet-team .slick-next');
    rightButton.classList.remove('slick-disabled');
    if (this.isLastSlide(slide)) {
      rightButton.classList.add('slick-disabled');
    }
  }

  updateSlideInfo (currentSlide) {
    let index = Math.ceil(((currentSlide ? currentSlide : 0) + 1) / this.portraitsToScroll());
    let totalSlides = this.totalSlides();
    if (index <= totalSlides) {
      document.querySelector('.slide-info').textContent = `${index}/${totalSlides}`;
      this.updateDisabledArrows(index || 1);
    }
  }

  fixTrackSliderWidth () {
    let trackWidth = this.slideItemWidth * this.sliderItemCount;
    document.querySelector('#meet-team .slick-track').style.width = `${trackWidth}px`;
  }

  next () {
    $('#TeamSlider').slick('slickNext');
  }

  previous () {
    $('#TeamSlider').slick('slickPrev');
  }

  componentDidMount () {
    $('#TeamSlider').slick(this.sliderSettings());
    $('#TeamSlider').on('init reInit afterChange beforeChange', (event, slick, currentSlide, nextSlide) => {
      this.updateSlideInfo(currentSlide);
    });
    this.fixTrackSliderWidth();
    this.updateSlideInfo();
    teamScene();
  }

  sliderSettings () {
    return {
      autoplay: false,
      arrows: false,
      dots: false,
      slidesToShow: PORTRAITS_PER_SLIDE,
      slidesToScroll: PORTRAITS_TO_SCROLL,
      infinite: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: PORTRAITS_PER_MOBILE_SLIDE,
            slidesToScroll: PORTRAITS_MOBILE_TO_SCROLL,
          },
        },
      ],
    };
  }

  render () {
    let { theme, profileSliderData } = this.props;
    return (
      <div>
        <article id="meet-team" className="layout-standard bg-white clearfix">
          <div className="wrapper">
            <h2>Meet the Team</h2>
            <div className="view view-team-members view-id-team_members view-display-id-team_slider view-dom-id-9775f4a9f4a774ac3845f1313acac329">
              <div id="TeamSlider" className={`view-content ${theme.TeamSlider}`}>
                {profileSliderData
                  .sort((a, b) => Number.parseInt(a.priority) - Number.parseInt(b.priority))
                  .map((item, index) => (
                    <div key={item.name} className={`views-row views-row-${index + 1} views-row-${index + 1 % 2 !== 0 ? 'odd' : 'even'} ${index + 1 === 1 && 'views-row-first'} small-4 columns`}>
                      <Profile profileData={item} profileNumber={index + 1} />
                    </div>
                  ))}
              </div>
              <div className="view-content slick-slider slide-button-container">
                <button onClick={() => this.previous()} type="button" className="slick-prev" />
                <span className="slide-info" />
                <button onClick={() => this.next()} type="button" className="slick-next" />
              </div>
            </div>
          </div>
        </article>
      </div>
    );
  }
}

TeamSection.propTypes = {
  profileSliderData: PropTypes.arrayOf(PropTypes.object),
};

themeable(TeamSection, {
  classes: [
    'TeamSlider',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/AboutUs/TeamSection.jsx